import React from "react";
import { Helmet } from "react-helmet-async";

export default function Terms() {
  return (
    <div className="page">
      <Helmet>
        <title>photoLevs: Terms</title>
      </Helmet>

      <h1 className="page-title">Terms and Conditions</h1>

      <div className="prose">
        <h2>Definitions</h2>
        <p>
          For the purposes of this agreement, “The Photographer” is Joseph
          Levermore trading as photoLevs, and “Images” means any images
          furnished by The Photographer, whether photographs, prints or other
          type of physical or electronic material.
        </p>

        <h2>Copyright and Ownership of Materials</h2>
        <p>
          The entire copyright, title, and intellectual property rights of any
          Images will remain that of The Photographer at all times throughout
          the world.
        </p>

        <h2>Right to a Credit</h2>
        <p>
          The Photographer asserts both his moral right to be identified as the
          author of his work and the right to a credit (where possible) is
          asserted in accordance with Sections 77 – 79 of the Copyright,
          Designs and Patents Act 1988 or any amendment or re‑enactment
          thereof. Please credit ‘photoLevs. Photography’.
        </p>

        <h2>Use</h2>
        <p>
          Images are to be used as agreed at the time of booking and at the
          time of agreeing the fee. The licence to use is limited to the use
          and period of time specified on The Photographer’s booking form and
          no other use may be made of the Images without the Photographer’s
          express permission. An agreement must be reached with The Photographer
          before Images are used for any other purpose or after the licence to
          use has expired.
        </p>
        <p>
          Manipulation of the Images or use of only a portion of Image may only
          take place with the permission of the Photographer.
        </p>
        <p>
          When the licence to use has expired an additional charge has to be
          agreed for extended usage with the Photographer.
        </p>

        <h2>Exclusivity</h2>
        <p>
          The usage rights granted are personal to the Client and may not be
          assigned, nor may any image submitted to the Client be loaned or
          transferred to third parties (save for the purpose of the work by the
          Client of such reproduction/usage rights/PR).
        </p>
        <p>
          The Photographer reserves the right to refuse to supply or grant a
          reproduction licence to a third party when requested to do so by the
          Client.
        </p>
        <p>
          The Photographer retains the right in all cases to use the Images
          covered by this agreement at any time and in any part of the world
          for the purposes of advertising or otherwise promoting his work.
        </p>

        <h2>Archiving of Images</h2>
        <p>
          All final images will be stored and archived by The Photographer for
          1 year. If archived photographs are required after that time or
          additional storage time is required an admin. fee may be charged. If
          The Photographer loses images stored in archive or they are stolen,
          The Photographer is not liable beyond 1 year of storage. Within 1
          year, The Photographer is liable to the cost of the originals (a
          return of the original fee).
        </p>

        <h2>Applicable Law</h2>
        <p>This agreement shall be governed by the laws of England and Wales.</p>

        <h2>Variation</h2>
        <p>
          No variation of terms and conditions set out herein shall be effective
          unless agreed in writing by both parties.
        </p>
      </div>
    </div>
  );
}